import { getChurnBenchmark } from '@atlassian/mpac-api-client';
import { hooks, log } from '@atlassian/mpac-utils';
export const useCloudChurnBenchmark = (mpacBaseUrl, partnerId, queryParams) => {
  const {
    result,
    error,
    pending
  } = hooks.usePromise(() => getChurnBenchmark(mpacBaseUrl, partnerId, queryParams), [queryParams]);
  if (error) {
    log.error('CloudChurnBenchmark/hooks', "Failed to retrieve reports }", {
      error
    });
  }
  return {
    pending,
    error,
    cloudChurnBenchmarkAPIResponse: result
  };
};